import React from "react";
import { SectionHeader } from "@/components/common/section-header";
import { Stack, Box } from "@mui/system";
import { Skeleton } from "@mui/material";

interface RelatedBlogsSkeletonProps {
  headerText: string;
}

const RelatedBlogsSkeleton = ({ headerText }: RelatedBlogsSkeletonProps) => (
  <Stack
    component="section"
    data-testid="related-blogs-skeleton-section"
    spacing="40px"
    sx={{ paddingY: "40px", alignItems: "center" }}
  >
    <SectionHeader
      headerLevel="h2"
      headerText={headerText}
      headerSx={{ textTransform: "none !important", textAlign: "center" }}
      headerTestId="related-blogs-section-header"
    />
    <Box
      sx={{
        maxWidth: { xs: "30rem", md: "62rem", lg: "94rem" }
      }}
    >
      <Stack direction="row" spacing={3}>
        {[1, 2, 3].map((i) => (
          <Box
            key={i}
            sx={{
              width: "300px",
              borderRadius: "20px",
              overflow: "hidden",
              bgcolor: "background.default",
              boxShadow: 6,
              border: "1px solid",
              borderColor: "divider",
              display: "flex",
              flexDirection: "column"
            }}
          >
            <Skeleton
              variant="rectangular"
              width="100%"
              height={200}
              animation="wave"
              sx={{ borderRadius: 0 }}
            />
            <Stack
              spacing={2}
              sx={{ padding: "20px", height: "140px", justifyContent: "space-between" }}
            >
              <Skeleton
                variant="rectangular"
                width="100%"
                height={48}
                animation="wave"
                sx={{ borderRadius: "4px" }}
              />
              <Skeleton
                variant="rectangular"
                width="60%"
                height={16}
                animation="wave"
                sx={{ borderRadius: "4px" }}
              />
            </Stack>
          </Box>
        ))}
      </Stack>
    </Box>
  </Stack>
);

export default RelatedBlogsSkeleton;
